module.exports = __webpack_public_path__ + "img/faile.65e1a789.svg";